import exifData from '@/data/exif-data.json';

export interface ExifData {
  camera?: string;
  lens?: string;
  focalLength?: string;
  aperture?: string;
  shutterSpeed?: string;
  iso?: string;
  dateTaken?: string;
}

const exifMap = exifData as Record<string, ExifData>;

/**
 * Get EXIF data for an image by its path
 * @param imagePath - The image path (e.g., "/images/work/tour-photo.jpg")
 * @returns ExifData object or undefined if no EXIF data found
 */
export function getExifData(imagePath: string): ExifData | undefined {
  if (!imagePath) return undefined;

  // Try exact match first
  if (exifMap[imagePath]) {
    return exifMap[imagePath];
  }

  // Try without leading slash
  const withoutSlash = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;
  if (exifMap['/' + withoutSlash]) {
    return exifMap['/' + withoutSlash];
  }

  return undefined;
}

/**
 * Check if an image has any EXIF data
 */
export function hasExifData(imagePath: string): boolean {
  return getExifData(imagePath) !== undefined;
}

/**
 * Get all available EXIF data
 */
export function getAllExifData(): Record<string, ExifData> {
  return exifMap;
}
